import { depthFirst, isWritable } from "@lernetz/svelte-common";
import { get, writable } from "svelte/store";

export const processIn = (dto: any) =>
  depthFirst(dto, (i) => {
    return wrapStore(i);
  });

export const processOut = (dto: any) =>
  depthFirst(dto, (i) => {
    return unwrapStore(i);
  });

export function wrapStore(i: any) {
  if (i?.modelName && !isWritable(i)) return writable(i);
  return i;
}

export function unwrapStore(i: any) {
  if (isWritable(i)) return get(i);
  return i;
}
